import React from 'react';
import Grid from '../Grid';
import { Auth0BannerStyled, Title, ButtonWrapper, Button } from './styled';

const Auth0Banner = () => {
  return (
    <Auth0BannerStyled>
      <Grid>
        <Title>
          Never compromise <br /> on <em>identity</em>.
        </Title>
        <ButtonWrapper>
          <Button href="javascript:signup()" className="btn btn-lg btn-success">
            USE AUTH0 FOR FREE
          </Button>
          <Button className="btn btn-lg btn-default open-contact-form-modal">TALK TO SALES</Button>
        </ButtonWrapper>
      </Grid>
    </Auth0BannerStyled>
  );
};

export default Auth0Banner;



// WEBPACK FOOTER //
// ./src/pages/universal-login/components/Auth0Banner/Auth0Banner.js